<template>
  <div class="profile-area">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8">
          <div class="edit-profile-content card-box-style">
            <h3>Editar Informações do Perfil</h3>

            <form @submit.prevent="handleUpdateProfile">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Nome Completo</label>
                    <input
                      type="text"
                      v-model="profileForm.name"
                      class="form-control"
                      placeholder="Nome Completo"
                    />
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      v-model="profileForm.email"
                      class="form-control"
                      placeholder="Email"
                    />
                  </div>
                </div>

                <div v-if="error" class="col-lg-12 mb-3">
                  <div class="alert alert-danger">{{ error }}</div>
                </div>
                <div v-if="success" class="col-lg-12 mb-3">
                  <div class="alert alert-success">{{ success }}</div>
                </div>

                <div class="save-update">
                  <button type="submit" class="btn btn-primary me-2" :disabled="loading">
                    {{ loading ? 'A guardar...' : 'Atualizar Perfil' }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="edit-profile-content card-box-style">
            <h3>Alterar Senha</h3>
            <form @submit.prevent="handleUpdatePassword">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Nova Senha</label>
                    <input
                      type="password"
                      v-model="passwordForm.password"
                      class="form-control"
                      placeholder="Nova Senha"
                      minlength="6"
                    />
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Confirmar Nova Senha</label>
                    <input
                      type="password"
                      v-model="passwordForm.confirmPassword"
                      class="form-control"
                      placeholder="Confirmar Nova Senha"
                    />
                  </div>
                </div>

                <div v-if="passwordError" class="col-lg-12 mb-3">
                  <div class="alert alert-danger">{{ passwordError }}</div>
                </div>
                <div v-if="passwordSuccess" class="col-lg-12 mb-3">
                  <div class="alert alert-success">{{ passwordSuccess }}</div>
                </div>

                <div class="save-update">
                  <button type="submit" class="btn btn-primary me-2" :disabled="passwordLoading">
                    {{ passwordLoading ? 'A guardar...' : 'Atualizar Senha' }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import usersService from '../../services/usersService';
import authService from '../../services/authService';

export default {
  name: 'EditProfile',
  data() {
    return {
      profileForm: {
        name: '',
        email: '',
      },
      passwordForm: {
        password: '',
        confirmPassword: '',
      },
      loading: false,
      success: null,
      error: null,
      passwordLoading: false,
      passwordSuccess: null,
      passwordError: null,
    };
  },
  mounted() {
    this.loadProfile();
  },
  methods: {
    async loadProfile() {
      const user = authService.getUser();
      if (user) {
        this.profileForm.name = user.name || '';
        this.profileForm.email = user.email || '';
      }
      
      try {
        const freshUser = await usersService.getProfile();
        this.profileForm.name = freshUser.name || '';
        this.profileForm.email = freshUser.email || '';
      } catch (err) {
        console.error('Erro ao carregar perfil:', err);
      }
    },
    async handleUpdateProfile() {
      this.loading = true;
      this.error = null;
      this.success = null;

      try {
        await usersService.updateProfile({
          name: this.profileForm.name,
          email: this.profileForm.email,
        });
        this.success = 'Perfil atualizado com sucesso!';
        // Recarregar para garantir que o localStorage e o form estejam sincronizados
        await this.loadProfile();
      } catch (err) {
        this.error = err.response?.data?.message || 'Erro ao atualizar perfil';
      } finally {
        this.loading = false;
      }
    },
    async handleUpdatePassword() {
      if (this.passwordForm.password !== this.passwordForm.confirmPassword) {
        this.passwordError = 'As senhas não coincidem';
        return;
      }

      if (this.passwordForm.password.length < 6) {
        this.passwordError = 'A senha deve ter pelo menos 6 caracteres';
        return;
      }

      this.passwordLoading = true;
      this.passwordError = null;
      this.passwordSuccess = null;

      try {
        await usersService.updateProfile({
          password: this.passwordForm.password,
        });
        this.passwordSuccess = 'Senha atualizada com sucesso!';
        this.passwordForm.password = '';
        this.passwordForm.confirmPassword = '';
      } catch (err) {
        this.passwordError = err.response?.data?.message || 'Erro ao atualizar senha';
      } finally {
        this.passwordLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.edit-profile-content {
  h3 {
    font-size: 18px;
    margin-bottom: 30px;
  }
  label {
    margin-bottom: 10px;
    font-size: 14px;
  }
  .form-group {
    margin-bottom: 24px;
  }
}
</style>
